module.exports = __webpack_public_path__ + "img/circle1.8eb76a76.png";